import { Component, OnInit, ElementRef, Renderer2, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { PopupService } from '@ng-bootstrap/ng-bootstrap/util/popup';
import { lastValueFrom } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
	selector: 'shop-dashboard-page',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
})

export class DashboardComponent implements OnInit {

	points:number=0.00;

	constructor(@Inject(ElementRef) private el: ElementRef,@Inject(Renderer2) private renderer: Renderer2, public apiService:ApiService,@Inject(Router) public router:Router) {
	}

	async ngOnInit(): Promise<void> {			

		if(this.apiService.userInfo.length == 0 ){
			this.apiService.popupMsg("Sign in/Sign up", "Please sign in \n or create an account!","info");
			this.router.navigate(["/"]);
		}	
		else{
			//setup the orderd and the details for each order
			if(typeof window !== 'undefined'){
				this.apiService.usersOrders = await lastValueFrom(this.apiService.getUsersOrdersPromise());
				let tmp = this.apiService.usersOrders;
				for (let i=0; i<this.apiService.usersOrders?.length; i++){
					tmp[i].orderDetails = [];
					tmp[i].orderDetails = await lastValueFrom(this.apiService.getUsersOrderDetailsPromise(tmp[i].ORDERID));
				}
				this.points = Number(this.apiService.userInfo[0].CUST_POINT_Balance) - Number(this.apiService.userInfo[0].CUST_POINTS_Onhold);
			}
		}
	}

	viewTab($event: Event, prevId: number, nextId: number) {
		$event.preventDefault();
		let nodes = this.el.nativeElement.querySelectorAll(".nav-dashboard .nav-link");
		this.renderer.removeClass(nodes[prevId], 'active');
		this.renderer.addClass(nodes[nextId], 'active');
	}

	signoutClicked(event:any){
		event.preventDefault();
		this.apiService.userInfo = [];
		if (typeof window !== 'undefined') 
			localStorage.removeItem('loginData');
		this.router.navigate(["/"]);
	}

	saveClicked(event:any){
		event.preventDefault();
		let fname = (<HTMLInputElement>document.getElementById("fname")).value;
		let lname = (<HTMLInputElement>document.getElementById("lname")).value;
		let address = (<HTMLInputElement>document.getElementById("address")).value;
		let city = (<HTMLInputElement>document.getElementById("city")).value;
		let country = (<HTMLInputElement>document.getElementById("country")).value;
		let email = (<HTMLInputElement>document.getElementById("email")).value;
		let currentPass = (<HTMLInputElement>document.getElementById("currentPass")).value;
		let newPass = (<HTMLInputElement>document.getElementById("newPass")).value;
		let newPass2 = (<HTMLInputElement>document.getElementById("newPass2")).value; 
		//check if user is changing the password
		//check if one of the three passwords is not empty it means that the user is trying to change password
		if(currentPass != "" || newPass != "" || newPass2 != ""){
			//now check if all of them are input by the user otherwise display the appropriate message
			if(currentPass != "" && newPass != "" && newPass2 != ""){
				if(currentPass != this.apiService.userInfo[0].CUST_Password){
					this.apiService.popupMsg("Wrong Password!","Wrong password. Try again!","info");	
					return;				
				}
				else if(newPass != newPass2){
					this.apiService.popupMsg("Passwords mismatch","New password and confirm new password \n must be the same!","info");
					return;
				}
				else{
					//everything ok proceed saving the new pass and the rest of the info
					this.updateUsersInfo(fname,lname,address,city,country,email,newPass);
				}
			}
			else{
				this.apiService.popupMsg("Password Required","All password fields are required!","info");
				return;
			}
		}
		//update user info apart the password
		this.updateUsersInfo(fname,lname,address,city,country,email,newPass);
	}

	async updateUsersInfo(fname: string, lname: string, address: string, city: string, country: string, email: string, newPass: string) {
		type MyArrayType = Array<{Column_Name: string, Column_Value: string}>;
			  
		let Col_Value: MyArrayType = [
			{Column_Name: 'CUST_USERNAME', Column_Value: email},
			{Column_Name: 'CUSTNAME', Column_Value: fname + " " + lname},
			{Column_Name: 'CUSTSURNAME', Column_Value: lname},         
			{Column_Name: 'CUSTADDRESS', Column_Value: address},
			{Column_Name: 'CUSTEMAIL', Column_Value: email},                  
			{Column_Name: 'CUSTCITY', Column_Value: city},
			{Column_Name: 'CUSTCOUNTRY', Column_Value: country},
			{Column_Name: 'CUSTID', Column_Value: this.apiService.userInfo[0].CUSTID.toString()}      		     
		];
		if(newPass != ""){
			Col_Value.push({Column_Name: 'CUST_Password', Column_Value: newPass});
		}
		let res = await lastValueFrom(this.apiService.getSavePromise("CUSTOMERS",true,Col_Value,"CUSTID"));
		if(res != "success"){
			this.apiService.popupMsg("Something went wrong",res,"error");
		}
		else{
			this.apiService.userInfo = [];
			this.router.navigate(['/']);
		}
	}

	
}

